import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { CONNECTED_SOURCE_FOLDER_SYNC_STATUS } from '../../config/const.config';

const ContentSourceSyncStatus = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  multiple,
  disabled,
  sx,
  error,
}) => {
  const selectedValue = defaultValue || (multiple ? [] : null);
  const options = Object.keys(CONNECTED_SOURCE_FOLDER_SYNC_STATUS).map(
    (key) => CONNECTED_SOURCE_FOLDER_SYNC_STATUS[key]
  );

  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (multiple) {
      const selectedOptions = options.filter((option) =>
        selectedValue.includes(option.value)
      );
      setValue(selectedOptions);
    } else {
      const selectedOption =
        options.find((option) => option.value === selectedValue) || null;
      setValue(selectedOption);
    }
  }, [selectedValue]);

  return (
    <Autocomplete
      id={id}
      options={options}
      getOptionLabel={(option) => option?.label || ''}
      value={value}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onChange={(e, newValue) => {
        setValue(newValue);

        onChange({
          target: {
            name,
            value: multiple
              ? newValue.map((item) => item.value)
              : newValue?.value || '',
          },
        });
      }}
      multiple={multiple}
      disableCloseOnSelect={multiple}
      disabled={disabled}
      sx={sx}
      isOptionEqualToValue={(op, vl) => op.value === vl.value}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
          variant="filled"
          name={name}
        />
      )}
    />
  );
};

ContentSourceSyncStatus.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
ContentSourceSyncStatus.defaultProps = {
  multiple: false,
  disabled: false,
  sx: {},
  error: '',
};

export default ContentSourceSyncStatus;
